<template>
  <div>
    <el-dropdown @command="onClick" trigger="click" placement="bottom-start" class="me-1 mb-1">
      <span class="el-dropdown-link el-button btn mb-2 text-truncate el-button--default is-plain">
        <i :class="icon" class="pr5" v-if="icon"></i>
        {{ $i18n.t(name) }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="elem in list" :key="elem.key" :command="elem">
          {{ $i18n.t(elem.value) }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { get } from 'lodash'
import axios from '../../../axiosClient'
import mixinNotify from '../../../utils/mixin-notify'

export default {
  name: 'ImportTemplateButton',
  mixins: [mixinNotify],
  props: ['buttonStyle', 'icon', 'name', 'url', 'params'],
  data() {
    return {
      list: [
        { key: 'XLSX', value: 'XLSX' },
        { key: 'CSV', value: 'CSV' },
      ],
    }
  },
  methods: {
    getExtension: function (mimeType) {
      if (mimeType.includes('text/csv')) return 'csv'
      if (mimeType.includes('application/zip')) return 'zip'
      if (mimeType.includes('application/x-zip-compressed')) return 'zip'
      if (mimeType.includes('application/xlsx')) return 'xlsx'
      return ''
    },
    async onClick(option) {
      const parameters = {
        ...this.params,
        format: option.value,
      }

      const res = await axios().get(this.url, { params: parameters, responseType: 'blob' }).catch((error) => {
        this.showNotification({
          title: `error_${this.name}_title`,
          text: `error_${this.name}_message`,
          type: 'error',
        })
      })

      if (!res || !res.data) return
      const extension = this.getExtension(get(res, 'headers.content-type'))
      const url = window.URL.createObjectURL(new Blob([res.data]))
      let a = document.createElement('a')
      a.href = url
      a.download = `${get(res, 'headers.x-filename')}.${extension}`
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
  },
}
</script>
